import { t } from "i18next";
import { getVideoTimeLimits } from "./partnerConfig";

function isVideoFile(fileType: string): boolean {
  const fileTypeNoCodec =
    fileType.indexOf(";") !== -1 ? fileType.split(";")[0] : fileType;

  /* const allowedTypes = [
    "video/mp4",
    "video/webm",
    "video/ogg",
    "video/avi",
    "video/mkv",
    "video/mov",
  ]; */

  return fileTypeNoCodec.startsWith("video/");
}

function loadVideo(file: File) {
  const video = document.createElement("video");
  video.preload = "metadata";
  video.src = URL.createObjectURL(file);
  return video;
}

function isCorrectAspectRatio(video: HTMLVideoElement) {
  return video.videoHeight >= video.videoWidth * 1.1;
}

function isCorrectDuration(
  video: HTMLVideoElement,
  timeLimits: { min: number; max: number },
) {
  return (
    typeof video.duration === "number" &&
    video.duration >= timeLimits.min &&
    video.duration <= timeLimits.max
  );
}

export default function validateVideo(
  file: File,
  placeRef: string | null = null,
): Promise<boolean> {
  return new Promise((resolve, reject) => {
    if (!isVideoFile(file.type)) {
      reject(t("upload-video.alert-invalid-file-type"));
    }

    const video = loadVideo(file);
    const timeLimits = getVideoTimeLimits(placeRef);

    video.onloadedmetadata = () => {
      URL.revokeObjectURL(video.src);

      if (isCorrectAspectRatio(video)) {
        if (isCorrectDuration(video, timeLimits)) {
          resolve(true);
        } else {
          reject(
            t("upload-video.alert-invalid-duration", {
              min: timeLimits.min,
              max: timeLimits.max,
            }),
          );
        }
      } else {
        reject(t("upload-video.alert-invalid-orientation"));
      }
    };

    video.onerror = () => {
      URL.revokeObjectURL(video.src);

      reject(t("upload-video.alert-error-while-loading"));
    };
  });
}
